export const selectCategories = state => state.categories.categoryList;

export const selectCategoriesIsLoading = state => state.categories.isLoading;

export const selectCategoriesError = state => state.categories.error;
